import type { BrandConfig } from './types'

/** Proaxiv brand configuration. */
export const proaxivBrand: BrandConfig = {
  name: 'PROAXIV',
  hostname: 'app.proaxiv.com',

  logoUrl: '/brands/pax/og.png',
  faviconUrl: '/brands/pax/favicon.png',
  title: 'PROAXIV',

  // Injected by BrandProvider as a JS-created <link>, which (unlike a CSS @import) does
  // not block the page's load event when fonts.googleapis.com is unreachable. Covers all
  // weights the apps use (300/400/500/600/700).
  googleFontsUrl:
    'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap',

  colors: {
    light: {
      text: '#6b6375',
      textH: '#08060d',
      bg: '#ffffff',
      border: '#e5e4e7',
      codeBg: '#f4f3ec',
      accent: '#aa3bff',
      accentBg: 'rgba(170, 59, 255, 0.1)',
      accentBorder: 'rgba(170, 59, 255, 0.5)',
      socialBg: 'rgba(244, 243, 236, 0.5)',
      shadow: 'rgba(0, 0, 0, 0.1) 0 10px 15px -3px, rgba(0, 0, 0, 0.05) 0 4px 6px -2px',
    },
    dark: {
      text: '#9ca3af',
      textH: '#f3f4f6',
      bg: '#16171d',
      border: '#2e303a',
      codeBg: '#1f2028',
      accent: '#c084fc',
      accentBg: 'rgba(192, 132, 252, 0.15)',
      accentBorder: 'rgba(192, 132, 252, 0.5)',
      socialBg: 'rgba(47, 48, 58, 0.5)',
      shadow: 'rgba(0, 0, 0, 0.4) 0 10px 15px -3px, rgba(0, 0, 0, 0.25) 0 4px 6px -2px',
    },
  },

  fonts: {
    sans: "'Inter', system-ui, 'Segoe UI', Roboto, sans-serif",
    heading: "'Inter', system-ui, 'Segoe UI', Roboto, sans-serif",
    mono: 'ui-monospace, Consolas, monospace',
  },
}
